import styled from 'styled-components';

export const  DatePickerWrapper = styled.div`
  &&& {
    .date-range-picker {
      width: 100%;
    }

    .rdrDateRangePickerWrapper,
    .rdrCalendarWrapper,
    .rdrMonth {
      width: 100%;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  &&&& {
    margin: 0;
    .ant-checkbox {
      outline: 0;
      &:hover {
        outline: 0;
      }
      &:focus {
        outline: 0;
      }
    }
    .ant-checkbox-wrapper {
      display: flex;
      align-items: center;

      &:hover {
        outline: 0;
        border: 0;
      }
      &:focus {
        outline: 0;
        border: 0;
      }
    }

    .ant-checkbox-inner {
      width: 24px;
      height: 24px;
      border-radius: 7px;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      width: 24px;
      height: 24px;
      border-radius: 7px;
      background-color: ${({ theme }) => theme.colors.primary};
      border-color: ${({ theme }) => theme.colors.primary};
      outline: 0;
    }
    .ant-checkbox + span {
      font-weight: 400;
    }

    html body .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    html body .ant-checkbox:hover .ant-checkbox-inner,
    html body .ant-checkbox-input:focus + .ant-checkbox-inner {
      width: 24px;
      height: 24px;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      position: absolute;
      display: table;
      border: 3px solid #fff;
      border-top: 0;
      border-left: 0;
      -webkit-transform: rotate(45deg) scale(1) translate(-50%, -50%);
      transform: rotate(45deg) scale(1) translate(-50%, -50%);
      opacity: 1;
      -webkit-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
      transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
      content: ' ';
    }

    .ant-checkbox-inner::after {
      position: absolute;
      top: 50%;
      left: 22%;
      display: table;
      width: 7.714286px;
      height: 12.142857px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      -webkit-transform: rotate(45deg) scale(0) translate(-50%, -50%);
      transform: rotate(45deg) scale(0) translate(-50%, -50%);
      opacity: 0;
      -webkit-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),
        opacity 0.1s;
      transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
      content: ' ';
    }
  }
`;
